export const aboutData = {
  header: {
    title: "About Us",
    description:
      "At Grantyd, we believe small and grassroots nonprofits deserve access to the same powerful tools as the largest institutions. Our mission is simple: to help you get back to yours.",
  },
  content: {
    mainText:
      "Nonprofits don't fit a mold, and neither should the tools that support them. At Grantyd, we build technology that reflects how organizations actually work. From managing programs and grants to connecting systems and visualizing data, we help teams use technology in ways that feel natural, sustainable, and true to their mission.",
    ceoName: "Frankie Axam Fredrick, Co-Founder & CEO",
  },
  cta: {
    title: "Ready to use technology to supercharge your mission?",
    description: "Let's talk!",
    buttonText: "Get Started",
  },
};
